import React from "react";
import './KiQuote.scss';
import ola from '../../../assets/images/ola.png';

const content = {
	"quote": "Med KI som forstår naturlig språk og kontekst, har vi utviklet et søk som både gir tilgang til relevante rettskilder og bedre støtte i rettsanvendelsen. Vi håper mange av kundene hjelper oss med å videreutvikle KI-satsningen."
}

export default function KiQuote() {
	const { quote } = content;
	return(
		<div className="KiQuote">
			<p className="quote">"{quote}"</p>
			<img src={ola} alt="Ola Stenersen" />
			<div>
				<p className="author">Ola Stenersen</p>
				<p className="title">Markedssjef Lovdata</p>
			</div>
		</div>
	)
}